import React, { useEffect, useState } from "react";

const OtpInput = ({ otpValues, setOtpValues, onVerify, otpBtn, seconds, minutes, onOtpComplete }) => {

    useEffect(() => {
        if (otpValues.every((val) => val !== "")) {
          onOtpComplete(true);
        } else {
          onOtpComplete(false);
        }
      }, [otpValues]);

  const handleInput = (e, index) => {
    const value = e.target.value.replace(/\D/g, ""); // Only numbers allowed

    if (value.length <= 1) {
      const newOtpValues = [...otpValues];
      newOtpValues[index] = value;
      setOtpValues(newOtpValues);

      if (index < 3 && value) {
        document.getElementById(`otp-input-${index + 1}`).focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otpValues[index] && index > 0) {
      document.getElementById(`otp-input-${index - 1}`).focus();
    }
    if (e.key === "Enter" && otpValues.every((val) => val !== "")) {
      handleVerifyData();
    }
  };

  const handleVerifyData = () => {
    const otp = otpValues.join("");
    // onVerify(otp); 
    if (otp.length === 4) {
      onVerify(otp);
    } else {
      // Focus back to first input
      const firstInput = document.getElementById("otp-input-0");
      if (firstInput) {
        firstInput.focus();
      }
    }
  };


  return (
    <div className="otp-wrapper">
      <div>
      <form id="otp-form">
          <div className="form-group-wrap">
            {[...Array(4)].map((_, index) => (
              <div className="input-wrapper" key={index}>
                <input
                  type="text"
                  id={`otp-input-${index}`}
                  className="otp-form-control"
                  pattern="[0-9]*"
                  inputMode="numeric"
                  maxLength={1}
                  value={otpValues[index]}
                  onChange={(e) => handleInput(e, index)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                  autoFocus={index === 0}
                />
              </div>
            ))}
          </div>
        </form>
      </div>

      <div className="countdown-text">
        <div
            className="btn-text-wrap"
            disabled={seconds > 0 || minutes > 0}
            style={{
            color:
                seconds > 0 || minutes > 0
                ? "#92929291"
                : "rgba(49, 49, 49, 1)",
            }}
        >
            <button
            className="btn-resend"
            disabled={seconds > 0 || minutes > 0}
            style={{
                color:
                seconds > 0 || minutes > 0
                    ? "#92929291"
                    : "#0069B4",
            }}
            onClick={otpBtn}
            >
            Resend OTP 
            </button>
            
        </div>
        <div className="wrap-timer-text">
        <p className="otpnumber">In</p>
            {seconds > 0 || minutes > 0 ? (
                <p className="otpnumber">
                {minutes < 10 ? `0${minutes}` : minutes}:
                {seconds < 10 ? `0${seconds}` : seconds}
                </p>
            ) : (
                
                <p className="otpnumber">00:00</p>
                
            )}
        <p className="otpnumber">secs</p>
        </div>
        </div> 

    </div>
    
  );
};

export default OtpInput;
